<template>
	<div style="width: 980px;margin: 0 auto;">
		<div class="head">
			<el-carousel :interval="2000" arrow="always" height='200px'>
				<el-carousel-item v-for="(item,index) in headimgList" :key="index">
					<img :src="item.url" style="width: 100%;" />
				</el-carousel-item>
			</el-carousel>
		</div>
		<div>
			<pcBack></pcBack>
		</div>


		<div class="box_time">
			<!-- 大会日程 上午 -->
			<div>
				<div class="title_box" style="background-color: #fff;color:#145af5;font-size: 20px;margin-bottom: 10px;">
					会议框架日程
				</div>

				<!-- 切换栏 -->
				<div class="big_box">
					<div class="flex qiehuanBox">
						<div class="time_qiehuan" :class="myindex==1? 'blue':''" @click="time_qiehuan">
							4月9日
						</div>
						<div class="time_qiehuan" @click="time_qiehuan2" :class="myindex==2? 'blue':''">
							4月10日
						</div>
					</div>
				</div>

				<div v-show="myindex == 1">
					<div class="title_box">4月9日 上午</div>
					<div class="border_rc">
						<div class="title_box homecourt" style="margin: 3px 0;font-weight: bold;">主会场
							<span class="look_style" @click="mvenue">点击查看详情</span>
						</div>

						<el-row style="width: 100%;">
							<el-col :span="12">
								<div class="title_box">会议时间</div>
							</el-col>
							<el-col :span="12">
								<div class="title_box">会议内容</div>
							</el-col>
						</el-row>

						<el-row style="width: 100%;">
							<el-col :span="12" style="border-right: 2px solid  #cbcbcb">
								<div class="title_box homecourt border">08:00-08:30</div>
							</el-col>
							<el-col :span="12">
								<div class="title_box homecourt border">注册</div>
							</el-col>
						</el-row>

						<el-row style="width: 100%;">
							<el-col :span="12" style="border-right: 2px solid  #cbcbcb">
								<div class="title_box homecourt ">08:30-09:00</div>
							</el-col>
							<el-col :span="12">
								<div class="title_box homecourt ">开幕式，领导致辞</div>
							</el-col>
						</el-row>

						<el-row style="width: 100%;">
							<el-col :span="12" style="border-right: 2px solid  #cbcbcb">
								<div class="title_box homecourt border">09:00-09:30</div>
							</el-col>
							<el-col :span="12">
								<div class="title_box homecourt border">中国抗菌药物应用和管理现状</div>
							</el-col>
						</el-row>

						<el-row style="width: 100%;">
							<el-col :span="12" style="border-right: 2px solid  #cbcbcb">
								<div class="title_box homecourt ">09:30-11:00</div>
							</el-col>
							<el-col :span="12">
								<div class="title_box homecourt ">细菌真菌感染多学科领域进展</div>
							</el-col>
						</el-row>

						<el-row style="width: 100%;">
							<el-col :span="12" style="border-right: 2px solid  #cbcbcb">
								<div class="title_box homecourt border">11:00-11:45</div>
							</el-col>
							<el-col :span="12">
								<div class="title_box homecourt border">圆桌会议讨论抗菌药物合理应用及管理</div>
							</el-col>
						</el-row>

						<el-row style="width: 100%;">
							<el-col :span="12" style="border-right: 2px solid  #cbcbcb">
								<div class="title_box homecourt">11:45-12:45</div>
							</el-col>
							<el-col :span="12">
								<div class="title_box homecourt">卫星会</div>
							</el-col>
						</el-row>
					</div>


					<!-- 大会日程 下午 -->
					<div style="margin-top: 30px;">
						<div class="title_box">4月9日 下午</div>

						<!-- 27日循环开始 -->
						<div v-for="(itme,index) in conferenceHall" style="margin-top: 30px">
							<div class="border_rc">
								<div class="title_box homecourt" style="font-weight: bold;">{{ itme.title }}
									<span class="look_style" @click="itme.fenhui!=undefined?itme.fenhui():''">点击查看详情</span>
								</div>

								<el-row style="width: 100%;">
									<el-col :span="12">
										<div class="title_box">会议时间</div>
									</el-col>
									<el-col :span="12">
										<div class="title_box">会议内容</div>
									</el-col>
								</el-row>

								<el-row style="width: 100%;" v-for="(itme2,index2) in itme.content">
									<el-col :span="12" style="border-right: 2px solid  #cbcbcb">
										<div class="title_box homecourt " :class="(index2%2) == 0? 'border':''">{{ itme2.time }}</div>
									</el-col>
									<el-col :span="12">
										<div class="title_box homecourt" :class="(index2%2) == 0? 'border':''">{{ itme2.text }}</div>
									</el-col>
								</el-row>
							</div>
						</div>
					</div>
				</div>

				<!-- 循环结束 -->

				<div v-show="myindex == 2">
					<div class="title_box">4月10日</div>

					<!-- 28日循环开始 -->

					<div v-for="(itme,index) in conferenceHall2" style="margin-top: 30px">
						<div class="border_rc">
							<div class="title_box homecourt" style="font-weight: bold;">{{ itme.title }}
								<span class="look_style" @click="itme.details">点击查看详情</span>
							</div>

							<el-row style="width: 100%;">
								<el-col :span="12">
									<div class="title_box">会议时间</div>
								</el-col>
								<el-col :span="12">
									<div class="title_box">会议内容</div>
								</el-col>
							</el-row>

							<!-- 上午 -->
							<el-row style="width: 100%;" v-for="(itme3,index2) in itme.morning">
								<el-col :span="12" style="border-right: 2px solid  #cbcbcb">
									<div class="title_box homecourt " :class="(index2%2) == 0? 'border':''">{{ itme3.time }}</div>
								</el-col>
								<el-col :span="12">
									<div class="title_box homecourt" :class="(index2%2) == 0? 'border':''">{{ itme3.text }}</div>
								</el-col>
							</el-row>
							<div v-if="itme.content.length != 0" style="background-color: #b6b6b6;text-align: center;color: #0f40d4;height: 30px;line-height: 30px;font-weight: bold;">
								下午
							</div>
							<el-row style="width: 100%;" v-for="(itme2,index2) in itme.content">
								<el-col :span="12" style="border-right: 2px solid  #cbcbcb">
									<div class="title_box homecourt " :class="(index2%2) == 0? 'border':''">{{ itme2.time }}</div>
								</el-col>
								<el-col :span="12">
									<div class="title_box homecourt" :class="(index2%2) == 0? 'border':''">{{ itme2.text }}</div>
								</el-col>
							</el-row>
						</div>
					</div>
				</div>
				<!-- 2循环结束 -->
			</div>
		</div>
		<div style="height: 80px"></div>
	</div>
</template>

<script>
	import pcBack from '../../../components/back/back.vue';
	export default {
		data() {
			return {
				myindex: 1,
				headimgList: [{
					url: require("@/assets/headImg/head.jpg"),
					id: 1
				}],
				conferenceHall: [{
						title: '分 会 场 1',
						content: [{
								time: '13:00-15:00',
								text: '复杂性尿路感染多学科诊疗'
							},
							{
								time: '15:00-15:15',
								text: '休息'
							},
							{
								time: '15:15-16:15',
								text: '卫星会'
							},
							{
								time: '16:15-17:45',
								text: '综合医院会诊/门诊不期而遇的STD'
							}
						],
						id: 1,
						fenhui: () => {
							this.$router.push({
								path: '/details',
								query: {
									myindex: '1'
								}
							})
						}
					},
					{
						title: '分 会 场 2',


						content: [{
								time: '13:00-15:00',
								text: '重症专家谈重症新冠肺炎继发感染的诊治'
							},
							{
								time: '15:00-15:15',
								text: '休息'
							},
							{
								time: '15:15-16:15',
								text: '卫星会'
							},
							{
								time: '16:15-17:45',
								text: '重症新冠肺炎医院感染的预防'
							}
						],
						id: 2,
						fenhui: () => {
							this.$router.push({
								path: '/details',
								query: {
									myindex: '2'
								}
							})
						}
					},
					{
						title: '分 会 场 3',
						content: [{
								time: '13:00-15:00',
								text: 'CRO挑战与应对'
							},
							{
								time: '15:00-15:15',
								text: '休息'
							},
							{
								time: '15:15-16:15',
								text: '卫星会'
							},
							{
								time: '16:15-17:45',
								text: 'CRO多学科防控'
							}
						],
						id: 3,
						fenhui: () => {
							this.$router.push({
								path: '/details',
								query: {
									myindex: '3'
								}
							})
						}
					},
					{
						title: '分 会 场 4',
						content: [{
								time: '13:00-15:00',
								text: '儿科感染多学科诊疗'
							},
							{
								time: '15:00-15:15',
								text: '休息'
							},
							{
								time: '15:15-16:15',
								text: '卫星会'
							},
							{
								time: '16:15-17:45',
								text: '抗菌药物的经验治疗'
							}
						],
						id: 4,
						fenhui: () => {
							this.$router.push({
								path: '/details',
								query: {
									myindex: '4'
								}
							})
						}
					}, {
						title: '分 会 场 5',
						content: [{
								time: '13:00-15:00',
								text: '卓越基础研究专题'
							},
							{
								time: '15:00-16:15',
								text: '休息'
							},
							// {
							//   time: '15:15-16:15',
							//   text: '卫星会'
							// },
							{
								time: '16:15-17:45',
								text: 'one health 理念下的耐药菌防控'
							}
						],
						id: 5,
						fenhui: () => {
							this.$router.push({
								path: '/details',
								query: {
									myindex: '5'
								}
							})
						}
					}, {
						title: '分 会 场 6',
						content: [{
								time: '13:00-15:00',
								text: '抗菌药物的真实世界研究'
							},
							{
								time: '15:00-16:15',
								text: '休息'
							},
							// {
							// 	time: '15:15-16:15',
							// 	text: '卫星会'
							// },
							{
								time: '16:15-17:45',
								text: 'AMS 抗菌药物管理'
							}
						],
						id: 6,
						fenhui: () => {
							this.$router.push({
								path: '/details',
								query: {
									myindex: '6'
								}
							})
						}
					}
				],

				conferenceHall2: [{
						title: '分 会 场 1',
						morning: [{
								time: '8:00-10:00',
								text: '免疫抑制宿主肺部感染'
							},
							{
								time: '10:00-10:15',
								text: '休息'
							},
							{
								time: '10:15-11:45',
								text: '免疫抑制宿主肺部感染的治疗'
							},
							{
								time: '11:45-12:45',
								text: '卫星会'
							}
						],
						content: [{
								time: '13:00-15:00',
								text: '病例讨论'
							},
							{
								time: '15:00-15:15',
								text: '休息'
							},
							{
								time: '15:15-17:15',
								text: '病例讨论'
							}
						],
						id: 1,
						details: () => {
							this.$router.push({
								path: '/details',
								query: {
									myindex: '7'
								}
							})
						}
					},
					{
						title: '分 会 场 2',
						morning: [{
								time: '8:00-10:00',
								text: '微生物检测新技术'
							},
							{
								time: '10:00-10:15',
								text: '休息'
							},
							{
								time: '10:15-11:45',
								text: '真菌与细菌药敏折点的制定及更新'
							},
							{
								time: '11:45-12:45',
								text: '卫星会'
							}
						],
						content: [{
								time: '13:00-15:00',
								text: '微生物与临床结合之四部曲'
							},
							{
								time: '15:00-15:15',
								text: '休息'
							},
							{
								time: '15:15-17:15',
								text: '病例MDT实战：病繁菌简，柳暗花明'
							}
						],
						id: 2,
						details: () => {
							this.$router.push({
								path: '/details',
								query: {
									myindex: '8'
								}
							})
						}
					},
					{
						title: '分 会 场 3',
						morning: [{
								time: '8:00-10:00',
								text: '侵袭性真菌病研究进展'
							},
							{
								time: '10:00-10:15',
								text: '休息'
							},
							{
								time: '10:15-11:45',
								text: '少见真菌病诊治进展'
							},
							{
								time: '11:45-12:45',
								text: '卫星会'
							}
						],
						content: [{
								time: '13:00-15:00',
								text: '酵母菌感染诊治进展'
							},
							{
								time: '15:00-15:15',
								text: '休息'
							},
							{
								time: '15:15-17:15',
								text: '丝状真菌感染诊治进展'
							}
						],
						id: 3,
						details: () => {
							this.$router.push({
								path: '/details',
								query: {
									myindex: '9'
								}
							})
						}
					},
					{
						title: '分 会 场 4',
						morning: [{
								time: '8:00-10:00',
								text: '粒缺发热诊治进展'
							},
							{
								time: '10:00-10:15',
								text: '休息'
							},
							{
								time: '10:15-11:45',
								text: '致死性肺部毛霉菌病的1例临床诊疗'
							},
							{
								time: '11:45-12:45',
								text: '卫星会'
							}
						],
						content: [{
								time: '13:00-15:00',
								text: '医院感染与水'
							},
							{
								time: '15:00-15:15',
								text: '休息'
							},
							{
								time: '15:15-17:15',
								text: '感染病的影像、病理诊断 '
							}
						],
						id: 4,
						details: () => {
							this.$router.push({
								path: '/details',
								query: {
									myindex: '10'
								}
							})
						}
					}, {
						title: '分 会 场 5',
						morning: [{
								time: '8:00-10:00',
								text: '细菌性传染病'
							},
							{
								time: '10:00-10:15',
								text: '休息'
							},
							{
								time: '10:15-11:45',
								text: '重症与临床药学'
							},
							// {
							// 	time: '11:45-12:45',
							// 	text: '卫星会'
							// }
						],
						content: [{
								time: '13:00-15:00',
								text: '中枢神经系统感染'
							},
							{
								time: '15:00-15:15',
								text: '休息'
							},
							{
								time: '15:15-17:15',
								text: '腹腔感染诊治进展'
							}
						],
						id: 5,
						details: () => {
							this.$router.push({
								path: '/details',
								query: {
									myindex: '11'
								}
							})
						}
					}, {
						title: '分 会 场 6',
						morning: [{
								time: '8:00-10:00',
								text: '青年论坛'
							},
							{
								time: '10:00-10:15',
								text: '休息'
							},
							{
								time: '10:15-11:45',
								text: '青年论坛'
							},
							// {
							// 	time: '11:45-12:45',
							// 	text: '卫星会'
							// }
						],
						content: [
							//     {
							//   time: '13:00-15:00',
							//   text: '培立方'
							// },
							//   {
							//     time: '15:00-15:15',
							//     text: '休息'
							//   },
							//
							//   {
							//     time: '15:15-17:45',
							//     text: ''
							//   }
						],
						id: 6,
						details: () => {
							this.$router.push({
								path: '/details',
								query: {
									myindex: '12'
								}
							})
						}
					}
				]
			}
		},
		methods: {
			retrun: function() {
				this.$router.push({
					path: '/'
				})
			},
			mvenue() {
				this.$router.push({
					path: '/details',
					query: {
						myindex: 'zuhui'
					}
				})
			},
			time_qiehuan() {
				this.myindex = 1
			},
			time_qiehuan2() {
				this.myindex = 2
			}
		},
		created() {
			if (this.$route.query.id == 2) {
				this.myindex = this.$route.query.id
			}
			let flag = navigator.userAgent.match(
				/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
			)
			if (flag) {
				this.$router.push({
					path: '/schedule-phone'
				})
			}

		},
		components:{
			pcBack
		}
	}
</script>

<style lang="scss" scoped>
	@import '@/assets/style/style.scss';


	.title_box {
		width: 100%;
		height: 35px;
		background-color: #145af5;
		text-align: center;
		line-height: 35px;
		font-weight: bold;
		color: #fff;
		font-family: 'Microsoft YaHei';
	}

	.homecourt {
		background-color: #e6e6e6;
		color: #0f40d4;
		position: relative;
		font-weight: 500;
	}

	.look_style {
		font-weight: 2300;
		font-size: 18px;
		position: absolute;
		right: 20px;
		cursor: pointer;
		color: red;
	}

	.border {
		border-top: 3px solid #cbcbcb;
		border-bottom: 3px solid #cbcbcb;
		background-color: #fff;
	}

	.box_time {
		width: 90%;
		margin: 0 auto;
	}

	.head {
		width: 100%;
	}

	.border_rc {
		border: 3px solid #145af5;
	}

	.time_qiehuan {
		font-size: 18px;
		color: #666;
		cursor: pointer;
	}

	.qiehuanBox {
		width: 300px;
		margin: 0 auto;
		margin-bottom: 20px;
	}

	.big_box {
		height: 35px;
		line-height: 35px;
		width: 100%;
		background-color: #efefef;
		margin-bottom: 15px;
	}

	.blue {
		color: #145af5;
		font-weight: bold;
		border-bottom: 2px solid #145af5;


	}
</style>
